"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Link_1 = __importDefault(require("../Link"));
const styles = require('./NavigationLinkMenu.module.scss');
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
// The mouse and key events are handled by separate elements in this component
const NavigationLinkMenu = ({ isSelected, type, sections, onMouseOver, onMouseLeave, onFocus, onBlur, }) => (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.root, { [styles.isSelected]: isSelected }), onMouseOver: onMouseOver, onMouseLeave: onMouseLeave },
    react_1.default.createElement("div", { className: styles.triangle }),
    react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.menu, [styles[`tablet${type}`]]) }, sections &&
        sections.map(({ category: analyticsCategory, action: analyticsAction, text, sections: links, path, rel, isOpenInNewWindow: isSectionOpenInNewWindow, hideDesktop, }, sectionIndex) => {
            if (hideDesktop) {
                return undefined;
            }
            return (react_1.default.createElement("div", { key: text, className: (0, classnames_1.default)(styles.category, {
                    [styles.tabletColumnAbove3]: sectionIndex > 2,
                }) },
                text && (react_1.default.createElement(Link_1.default, { className: styles.sectionTitle, trackingAttributes: {
                        category: analyticsCategory,
                        action: analyticsAction,
                        label: text.toLowerCase(),
                    }, href: path, rel: rel, onFocus: onFocus, target: isSectionOpenInNewWindow ? '_blank' : '_self' },
                    react_1.default.createElement("h3", { className: styles.h3 }, text))),
                react_1.default.createElement("ul", { className: styles.ul }, links &&
                    links.map(({ action: analyticsActionForHeading, category: analyticsCategoryForHeading, isOpenInNewWindow, path: linkPath, rel: linkRel, text: linkText, hideDesktop: linkHideDesktop, }, linksIndex) => {
                        if (linkHideDesktop) {
                            return undefined;
                        }
                        const isLastLink = sectionIndex + 1 === sections.length && linksIndex + 1 === links.length;
                        return (react_1.default.createElement("li", { key: linkText, className: styles.li },
                            react_1.default.createElement(Link_1.default, { className: styles.a, trackingAttributes: {
                                    category: analyticsCategoryForHeading,
                                    action: analyticsActionForHeading,
                                    label: linkText.toLowerCase(),
                                }, href: linkPath, onFocus: onFocus, onBlur: (e) => {
                                    if (isLastLink && onBlur) {
                                        onBlur(e);
                                    }
                                }, rel: linkRel, target: isOpenInNewWindow ? '_blank' : '_self' }, linkText)));
                    }))));
        }))));
exports.default = NavigationLinkMenu;
//# sourceMappingURL=NavigationLinkMenu.js.map